import { Quote } from "lucide-react";
import { useLang } from "@/i18n/LanguageContext";

export default function Testimonials() {
  const { t } = useLang();
  return (
    <section className="py-24 lg:py-32 bg-[#F9FAFB]" data-testid="testimonials-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="max-w-3xl mb-16">
          <p className="bbm-eyebrow mb-4">— {t.testimonials.eyebrow}</p>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl text-[#0B132B] leading-tight tracking-tight">
            {t.testimonials.title}
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {t.testimonials.items.map((it, i) => (
            <div
              key={i}
              className="bbm-card p-8 flex flex-col gap-6"
              data-testid={`testimonial-${i}`}
            >
              <Quote className="w-6 h-6 text-[#FFB800]" strokeWidth={1.5} />
              <p className="text-[#0B132B] text-base leading-relaxed flex-1">
                "{it.quote}"
              </p>
              <div>
                <div className="w-8 h-px bg-[#0B132B] mb-3" />
                <p className="font-mono text-[11px] uppercase tracking-widest text-[#4B5563]">
                  {it.role}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
